// projects.js
const Projects = [
    {
      title: 'Toast IQ',
      subtitle: 'Product Design @ Toast',
      description: 'Built the core system behind Toast IQ — bringing an AI assistant from 0 → GA across 40,000+ restaurant locations.',
      image: '/toastiq.png',
      link: '/toast-iq',
    },
    {
      title: 'AI Admin Tool',
      subtitle: 'Product Design @ Toast',
      description: 'Designed a tool to allow finetuning of AI agents by non-engineers.',
      image: '/admin-tool.png',
      link: '/admin-tool',
    },
    {
      title: 'Search & "The Donut"',
      subtitle: 'Product Design @ Toast',
      description: "Revamped the search experience as part of the Toast Web Operating System.",
      image: '/search.png',
      link: '/search',
    },
    {
      title: 'Manager Close Out',
      subtitle: 'Product Design @ Toast',
      description: 'Completely redesigned the end-of-day experience on Point of Sale devices.',
      image: '/manager-close-out.png',
      link: '/manager-close-out',
    },
    // {
    //   title: 'Gifting Program',
    //   subtitle: 'Product Design @ Drizly',
    //   description: "Led design on Drizly's gifting program ($2 million impact).",
    //   image: '/gifting.png',
    //   link: '/gifting-program',
    // },
  ];
  
  export default Projects;
  